const BSTypes = {
    TT_BS_ACTION_START:"TT_BS_ACTION_START",
    TT_BS_FETCH_DATA:"TT_BS_FETCH_DATA",
    TT_BS_FETCH_DATA_FAILED:"TT_BS_FETCH_DATA_FAILED",
    TT_BS_ADD_DATA:"TT_BS_ADD_DATA",
    TT_BS_SOCKET_UPDATE_DATA:"TT_BS_SOCKET_UPDATE_DATA",

    TT_BS_ACTION_START_FINANCIAL_STATEMENT:"TT_BS_ACTION_START_FINANCIAL_STATEMENT",
    TT_BS_FETCH_DATA_FINANCIAL_STATEMENT:"TT_BS_FETCH_DATA_FINANCIAL_STATEMENT",
    TT_BS_FETCH_DATA_FAILED_FINANCIAL_STATEMENT:"TT_BS_FETCH_DATA_FAILED_FINANCIAL_STATEMENT",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    set_payload: "",

    financialStatementLoading: false,
    financialStatementIsSuccess: false,
    financialStatementSet_payload: '',
    financialStatementResponse : [],
    financialStatement_error_message: null,
}

const TempTabBSReducer = (state=Initial_state, action) => {
    switch(action.type){
        case BSTypes.TT_BS_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case BSTypes.TT_BS_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.data,
                set_payload: action.payload.set_payload
            }

        case BSTypes.TT_BS_SOCKET_UPDATE_DATA:
            const { data, set_payload } = action.payload;
            if(state.set_payload !== set_payload){
                return {
                    ...state
                }
            }
            return {
                ...state,
                response: {
                    ...state.response,
                    balance_sheet: data.balance_sheet,
                    financial_statement: data.financial_statement
                }
            }

        case BSTypes.TT_BS_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }

        case BSTypes.TT_BS_ACTION_START_FINANCIAL_STATEMENT:
            return {
                ...state,
                financialStatementLoading: true,
            }

        case BSTypes.TT_BS_FETCH_DATA_FINANCIAL_STATEMENT: {
            const { data, set_payload } = action.payload;
            if(state.set_payload !== set_payload){
                return {
                    ...state
                }
            }
            return {
                ...state,
                response: {
                    ...state.response,
                    balance_sheet: data.balance_sheet,
                    financial_statement: data.financial_statement
                }
            }

        }
        case BSTypes.TT_BS_FETCH_DATA_FAILED_FINANCIAL_STATEMENT: 
            return {
                ...state,
                financialStatementLoading: false,
                financialStatementIsSuccess: false,
                financialStatement_error_message: action.payload
            }
        default:
            return state;
    }
};

export default TempTabBSReducer;